import { FONT_BASE } from 'game/constants/AppFonts';

export class DisplayOutcomeScore extends Phaser.GameObjects.Container {
  constructor(scene, data) {
    super(scene);
    scene.add.existing(this);

    this.scene = scene;
    this._data = data;
    this._type = data.type.replace('update_', '');

    this.width = 180;
    this.height = 60;

    this.setupBaseScoreProgress();
  }

  setupBaseScoreProgress() {
    this.text = this.scene.add.sprite(0, 0, 'scores', `score_${this._type}_text`).setOrigin(0.5, 0);
    this.bar = this.scene.add
      .sprite(0, 0, 'scores', `score_${this._type}_outcome`)
      .setOrigin(0.5, 0);
    this.bar.y = this.text.y + this.text.height;

    this.icon = this.scene.add
      .sprite(-(this.bar.width / 2 - 22), this.bar.y + 15, 'scores', `score_${this._type}_icon`)
      .setOrigin(0, 0);

    this.score = this.scene.add
      .text(
        -(this.bar.width / 2 - 22) + this.icon.displayWidth + 10,
        this.bar.y + this.bar.height / 2,
        `${this._data.score > 0 ? '+' : ''}${this._data.score}%`,
        {
          fontFamily: FONT_BASE.PIXEL_OPERATOR_HB_8,
          fontSize: '20px',
          color: '#ffffff',
        }
      )
      .setOrigin(0);

    this.score.y -= this.score.height / 2;

    this.add([this.text, this.bar, this.icon, this.score]);
  }

  shutdown() {
    this.timeline.destroy();
    this.destroy();
  }
}
